"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _upload = _interopRequireDefault(require("@/components/uploadImg/upload.vue"));
var _upgradeConfiguration = require("@/api/hierarchicalCommissionAllocation/upgradeConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    upload: _upload.default
  },
  data: function data() {
    return {
      itemKey: 'Update',
      ruleForm: {
        title: '',
        // 标题
        ConditionStatement: '',
        // APP宣传文字
        topBackground: '',
        // 顶部背景图
        upgradeChart: '',
        // 升级图
        dominantColor: '',
        // 主色
        ComplementaryColor: '',
        // 辅色
        BackgroundColor: '',
        // 背景色
        CardBackgroundColor: '',
        // 卡片背景色
        CardBorderColor: '',
        // 卡片边框色
        NicknameTextColor: '',
        // 昵称文字颜色
        UpgradeButtonBackgroundColor: '',
        // 升级按钮背景色
        UpgradeButtonTextColor: '',
        // 升级按钮文字颜色
        NounAnnotation: '',
        // 名词注释
        remark: '' // 备注
      },
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        topBackground: [{
          required: true,
          message: '请上传背景图',
          trigger: 'blur'
        }],
        upgradeChart: [{
          required: true,
          message: '请上传升级图',
          trigger: 'blur'
        }],
        dominantColor: [{
          required: true,
          message: '请输入主色',
          trigger: 'blur'
        }],
        ComplementaryColor: [{
          required: true,
          message: '请输入辅色',
          trigger: 'blur'
        }],
        BackgroundColor: [{
          required: true,
          message: '请输入背景色',
          trigger: 'blur'
        }],
        CardBackgroundColor: [{
          required: true,
          message: '请输入卡片背景色',
          trigger: 'blur'
        }],
        CardBorderColor: [{
          required: true,
          message: '请输入卡片边框色',
          trigger: 'blur'
        }],
        NicknameTextColor: [{
          required: true,
          message: '请输入昵称文字颜色',
          trigger: 'blur'
        }],
        UpgradeButtonBackgroundColor: [{
          required: true,
          message: '请输入升级按钮背景色',
          trigger: 'blur'
        }],
        UpgradeButtonTextColor: [{
          required: true,
          message: '请输入升级按钮文字颜色',
          trigger: 'blur'
        }],
        NounAnnotation: [{
          required: true,
          message: '请输入名词注释',
          trigger: 'blur'
        }]
      },
      wayList: [{
        name: '升级途径一',
        id: 1
      }, {
        name: '升级途径二',
        id: 2
      }, {
        name: '升级途径三',
        id: 3
      }],
      wayList1: [{
        name: '当前权益',
        id: 1
      }, {
        name: '导师权益',
        id: 2
      }]
    };
  },
  created: function created() {
    this.getSetting();
  },
  methods: {
    getSetting: function () {
      var _getSetting2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                // appId: 101,
                itemKey: this.itemKey
              };
              _context.n = 1;
              return (0, _upgradeConfiguration.getSetting)(params);
            case 1:
              res = _context.v;
              if (res.data !== '') {
                this.ruleForm = {};
                this.ruleForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.ruleForm), JSON.parse(res.data));
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getSetting() {
        return _getSetting2.apply(this, arguments);
      }
      return getSetting;
    }(),
    saveSetting: function () {
      var _saveSetting2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                itemKey: this.itemKey,
                itemValue: JSON.stringify(this.ruleForm)
              };
              _context2.n = 1;
              return (0, _upgradeConfiguration.saveSetting)(params);
            case 1:
              res = _context2.v;
              if (res.data) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.getSetting();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function saveSetting() {
        return _saveSetting2.apply(this, arguments);
      }
      return saveSetting;
    }(),
    onPictureAddress: function onPictureAddress(data) {
      this.ruleForm[data.name] = data.pictureUrl;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认修改升级中心设置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.saveSetting();
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};